export const COLORS = {
    background: "#f9f9fb",
    surfaceLowest: "#ffffff",
    surfaceLow: "#f3f3f5",
    surface: "#eeeef0",
    surfaceHigh: "#e8e8ea",
    surfaceHighest: "#e2e2e4",
    primary: "#000000",
    onPrimary: "#ffffff",
    onSurface: "#1a1c1d",
    onSurfaceVariant: "#45464c",
    outline: "#76777d",
    outlineVariant: "#c6c6cd",
    border: "rgba(198, 198, 205, 0.4)",
    borderSubtle: "rgba(198, 198, 205, 0.2)",
    secondary: "#006c49",
    onSecondary: "#ffffff",
    secondaryContainer: "rgba(108, 248, 187, 0.3)",
    secondaryContainerBorder: "rgba(108, 248, 187, 0.5)",
    onSecondaryContainer: "#00714d",
    error: "#ba1a1a",
};

/** Matches SignalSight: MUI default for controls, 8px icon chips, 10px cards. */
export const RADIUS = {
    control: "4px",
    chip: "8px",
    card: "10px",
    full: "9999px",
};

export const SHADOW = {
    sm: "0 1px 2px rgba(0, 0, 0, 0.05)",
    footer: "0 -4px 16px rgba(0, 0, 0, 0.03)",
};

export const TYPOGRAPHY = {
    display: {
        fontSize: "36px",
        lineHeight: "44px",
        letterSpacing: "-0.03em",
        fontWeight: 600,
    },
    headlineLg: {
        fontSize: "28px",
        lineHeight: "36px",
        letterSpacing: "-0.025em",
        fontWeight: 600,
    },
    headlineLgMobile: {
        fontSize: "22px",
        lineHeight: "28px",
        letterSpacing: "-0.02em",
        fontWeight: 600,
    },
    headlineMd: {
        fontSize: "20px",
        lineHeight: "26px",
        letterSpacing: "-0.02em",
        fontWeight: 600,
    },
    headlineSm: {
        fontSize: "16px",
        lineHeight: "22px",
        letterSpacing: "-0.015em",
        fontWeight: 600,
    },
    bodyLg: {
        fontSize: "15px",
        lineHeight: "24px",
        letterSpacing: "-0.01em",
        fontWeight: 400,
    },
    bodyMd: {
        fontSize: "13px",
        lineHeight: "20px",
        letterSpacing: "-0.005em",
        fontWeight: 400,
    },
    bodySm: {
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0em",
        fontWeight: 400,
    },
    labelMd: {
        fontSize: "13px",
        lineHeight: "18px",
        letterSpacing: "-0.01em",
        fontWeight: 500,
    },
    labelSm: {
        fontSize: "11px",
        lineHeight: "14px",
        letterSpacing: "0.02em",
        fontWeight: 500,
    },
    overline: {
        fontSize: "11px",
        lineHeight: "14px",
        letterSpacing: "0.05em",
        fontWeight: 600,
        textTransform: "uppercase" as const,
    },
};

export const MAIN_MAX_WIDTH = "1080px";

/** Zoho, AppsFlyer and Adjust allow selecting several sources of the same type. */
export const MULTI_SOURCE_TYPE_IDS = [6, 21, 25];

export const WIZARD_MODAL_CONTEXT = "wizard";

export const LIST_INITIAL_COUNT = 10;
export const LIST_BATCH_SIZE = 10;
